<script lang="ts" setup>
import LayoutEnum from '~/enums/LayoutEnum'
import { Routes } from '~/enums/Routes'
import getLocalizedRoute from '~/utils/getLocalizedRoute'

const { type } = defineProps<{ type?: LayoutEnum.Market | LayoutEnum.Quote }>()
const { t } = useLang()
const route = useRoute()
const isCategoryPage = computed(() => route.meta.key === 'category')
const { isTarpininke } = useTheme()
</script>

<template>
  <div class="jav-header-nav">
    <div class="navbar">
      <nav class="nav flex gap-2 h-full" role="menubar">
        <NuxtLink
          :to="getLocalizedRoute(Routes.Index)"
          class="nav-item dealzone"
          :class="{ active: type === LayoutEnum.Market && !isCategoryPage }">
          {{ t('common.main-page') }}
        </NuxtLink>

        <NuxtLink
          v-if="!isTarpininke"
          :to="getLocalizedRoute(Routes.OrderForm.Index)"
          class="nav-item quote"
          :class="{ active: type === LayoutEnum.Quote }">
          {{ t('quotes.order-form') }}
        </NuxtLink>
        <NuxtLink
          v-if="isTarpininke"
          class="nav-item quote"
          :to="getLocalizedRoute(Routes.CategorySlug)"
          :class="{ active: isCategoryPage }">
          {{ t('common.outlet') }}
        </NuxtLink>
      </nav>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.jav-header-nav {
  height: 100%;

  .navbar {
    color: theme('colors.white');
    padding: 0;
    box-shadow: none;
    margin-left: 26px;
    border: 0;
    height: 100%;

    .nav {
      flex-wrap: nowrap;

      .nav-item {
        font-size: 1.125rem;
        display: flex;
        align-items: center;
        padding: 1.25rem 1rem;
        font-weight: 400;
        background-color: theme('colors.brand.primary');
        height: 100%;
        border-bottom: 2px solid transparent;
        text-wrap: nowrap;
        P &:hover {
          background-color: theme('colors.brand.primaryHover');
        }

        &.active {
          font-weight: 600;
          background-color: theme('colors.brand.primaryHover');
          border-bottom: 2px solid theme('colors.red.DEFAULT');
        }
      }
    }
  }
}

.tp {
  .nav-item {
    font-weight: 600 !important;
  }
}
</style>
